import { useEffect } from "react";
import { cookies } from "@clarion/foundation/dist/Utils/cookieUtils";
import { CIVIC_COOKIE_CONTROL_COOKIE } from "@clarion/foundation/dist/Settings/constants/cookies";
import "./index.css";
const CookieBanner = ({
  fields,
  optionalCookies,
  necessaryCookies = []
}) => {
  const privacyPolicyDateField = fields.PrivacyPolicyUpdated;
  let privacyPolicyDate = "";
  let privacyPolicyDateFormatted = "";

  // Format privacy policy update date format
  if (typeof privacyPolicyDateField !== "undefined" && privacyPolicyDateField.value !== "") {
    privacyPolicyDate = new Date(privacyPolicyDateField.value);
    privacyPolicyDateFormatted = privacyPolicyDate.toLocaleDateString("en-GB");
  }
  useEffect(() => {
    const script = document.createElement("script");
    const config = {
      apiKey: "6eee20de5ac1af8ff3cd16b7eface2277c3cb51f",
      product: "PRO_MULTISITE",
      initialState: "notify",
      notifyDismissButton: "false",
      closeStyle: "button",
      mode: "gdpr",
      text: {
        title: fields.SlideTitle.value,
        intro: fields.SlideDescription.value,
        necessaryTitle: fields.NecessaryName.value,
        necessaryDescription: fields.NecessaryDescription.value,
        accept: fields.AcceptCookiesLabel.value,
        acceptSettings: fields.AcceptButtonLabel.value,
        settings: fields.ManageCookiesLabel.value,
        notifyTitle: fields.Heading.value,
        notifyDescription: fields.Body.value,
        closeLabel: fields.CloseButton.value,
        landmark: fields.LandmarkLabel.value
      },
      rejectButton: false,
      setInnerHTML: true,
      settingsStyle: "button",
      statement: {
        description: fields.PrivacyPolicyDescription.value,
        name: fields.PrivacyPolicyName.value,
        url: fields.PrivacyPolicyUrl.value?.href,
        updated: privacyPolicyDateFormatted
      },
      necessaryCookies: necessaryCookies,
      optionalCookies: optionalCookies,
      position: "right",
      theme: "light",
      branding: {
        backgroundColor: "#fffffff",
        removeIcon: true,
        removeAbout: true
      },
      accessibility: {
        highlightFocus: true
      }
    };
    script.onload = () => {
      const cookieControlCookie = cookies.get(CIVIC_COOKIE_CONTROL_COOKIE);
      window.CookieControl.load(config);

      // Logic around forcing banner to pop up if content editor changes privacy policy updated date field
      if (cookieControlCookie) {
        const previouslyUpdatedDate = JSON.parse(cookieControlCookie)?.statement?.updated;
        if (previouslyUpdatedDate !== privacyPolicyDateFormatted) {
          setTimeout(() => {
            // Timeout required since the notify() function isn't immediately available on window
            window.CookieControl.notify();
          }, 1000);
        }
      }
    };
    script.src = "https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return null;
};
export default CookieBanner;